<template>
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30 30"
    aria-hidden="true"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.56 5.44a1.5 1.5 0 0 0-2.12 2.12L19.88 13H7.5a1.5 1.5 0 0 0 0 3h12.38l-5.44 5.44a1.5 1.5 0 0 0 2.12 2.12l8-8a1.5 1.5 0 0 0 0-2.12l-8-8Z"
      fill="currentColor"
    />
  </svg>
</template>
